var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "table 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90.4981 74.5625C100.854 74.5625 107.982 77.3741 110.188 79.2481C110.188 79.2481 69.875 79.2463 69.875 79.2481C73.1844 77.3741 80.1425 74.5625 90.4981 74.5625Z",
    fill: "url(#paint0_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M114.875 34.25C110.457 36.1484 99.1442 52.8387 110.188 79.25L114.875 34.25Z",
    fill: "url(#paint1_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M70.8106 84.875H113.939C114.454 84.875 114.875 84.4541 114.875 83.9394V79.25H69.875V83.9394C69.875 84.4541 70.2959 84.875 70.8106 84.875Z",
    fill: "url(#paint2_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M109.25 79.25H114.875L118.625 35.1875C118.625 34.6634 118.212 34.25 117.688 34.25H113.938C113.413 34.25 113 34.6634 113 35.1875L109.25 79.25Z",
    fill: "url(#paint3_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M113 84.875L115.812 113C115.812 113.938 115.068 114.875 113.938 114.875C112.992 114.875 112.209 113.934 112.062 113L107.375 84.875H113Z",
    fill: "url(#paint4_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M70.8125 84.875L68 113C68 113.938 68.7444 114.875 69.875 114.875C70.8209 114.875 71.6037 113.934 71.75 113L76.4375 84.875H70.8125Z",
    fill: "url(#paint5_linear_454_12113)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M65.1921 12.6875C58.9568 28.13 65.0309 33.0528 65.1874 34.25C65.344 33.0528 71.4274 28.13 65.1921 12.6875Z",
    fill: "url(#paint6_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.8122 12.6875C49.5769 28.13 55.6557 33.0528 55.8122 34.25C55.9688 33.0528 62.0475 28.13 55.8122 12.6875Z",
    fill: "url(#paint7_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.5001 6.125C52.551 25.0494 59.5644 33.3125 60.5001 34.25C61.4357 33.3125 68.4491 25.0494 60.5001 6.125Z",
    fill: "url(#paint8_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M65.1875 44.5625H55.8125C55.3438 44.5625 54.92 44.0919 54.875 43.625L53.9375 33.3125H67.0625L66.125 43.625C66.08 44.0919 65.6562 44.5625 65.1875 44.5625Z",
    fill: "url(#paint9_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M67.9728 34.25H53.0272C52.4966 34.25 52.0625 33.8159 52.0625 33.2853V31.4647C52.0625 30.9341 52.4966 30.5 53.0272 30.5H67.9728C68.5034 30.5 68.9375 30.9341 68.9375 31.4647V33.2853C68.9375 33.8159 68.5034 34.25 67.9728 34.25Z",
    fill: "url(#paint10_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M30.5019 74.5625C20.1462 74.5625 13.0184 77.3741 10.8125 79.2481C10.8125 79.2481 51.125 79.2463 51.125 79.2481C47.8156 77.3741 40.8575 74.5625 30.5019 74.5625Z",
    fill: "url(#paint11_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M6.125 34.25C10.5434 36.1484 21.8562 52.8387 10.8125 79.25L6.125 34.25Z",
    fill: "url(#paint12_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M50.1894 84.875H7.06063C6.54594 84.875 6.125 84.4541 6.125 83.9394V79.25H51.125V83.9394C51.125 84.4541 50.7041 84.875 50.1894 84.875Z",
    fill: "url(#paint13_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.75 79.25H6.125L2.375 35.1875C2.375 34.6634 2.78844 34.25 3.3125 34.25H7.0625C7.58656 34.25 8 34.6634 8 35.1875L11.75 79.25Z",
    fill: "url(#paint14_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8 84.875L5.1875 113C5.1875 113.938 5.93188 114.875 7.0625 114.875C8.00844 114.875 8.79125 113.934 8.9375 113L13.625 84.875H8Z",
    fill: "url(#paint15_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M50.1875 84.875L53 113C53 113.938 52.2556 114.875 51.125 114.875C50.1791 114.875 49.3962 113.934 49.25 113L44.5625 84.875H50.1875Z",
    fill: "url(#paint16_linear_454_12113)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M29.5625 52.0625L19.25 113C19.25 113.938 19.9784 114.875 21.125 114.875C22.0438 114.875 22.8369 113.904 23 113L37.0625 52.0625H29.5625Z",
    fill: "url(#paint17_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M91.4375 52.0625L101.75 113C101.75 113.938 101.022 114.875 99.875 114.875C98.9563 114.875 98.1631 113.904 98 113L83.9375 52.0625H91.4375Z",
    fill: "url(#paint18_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M51.125 38C51.125 41.6244 45.2488 44.5625 38 44.5625C30.7513 44.5625 24.875 41.6244 24.875 38H51.125Z",
    fill: "url(#paint19_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M96.125 38C96.125 41.6244 90.2488 44.5625 83 44.5625C75.7513 44.5625 69.875 41.6244 69.875 38H96.125Z",
    fill: "url(#paint20_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M98.8981 52.0625H22.1019C21.5647 52.0625 21.125 51.6228 21.125 51.0856V45.5384C21.125 45.0022 21.5647 44.5625 22.1019 44.5625H98.8991C99.4362 44.5625 99.8759 45.0022 99.8759 45.5394V51.0866C99.875 51.6228 99.4353 52.0625 98.8981 52.0625Z",
    fill: "url(#paint21_linear_454_12113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M27.6875 44.5625L60.5 78.3125L93.3125 44.5625H27.6875Z",
    fill: "url(#paint22_linear_454_12113)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_12113",
    x1: 90.0312,
    y1: -25.9844,
    x2: 90.0312,
    y2: 133.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_454_12113",
    x1: 110.183,
    y1: -26.9219,
    x2: 110.183,
    y2: 132.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_454_12113",
    x1: 114.875,
    y1: 82.0625,
    x2: 69.875,
    y2: 82.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93634D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93634D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_454_12113",
    x1: 118.625,
    y1: 56.75,
    x2: 109.25,
    y2: 56.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17E51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_454_12113",
    x1: 111.594,
    y1: 75.5,
    x2: 111.594,
    y2: 81.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFB082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_454_12113",
    x1: 72.2188,
    y1: 75.5,
    x2: 72.2188,
    y2: 81.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFB082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_454_12113",
    x1: 62.4021,
    y1: 23.4688,
    x2: 63.799,
    y2: 23.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#809000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B7F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_454_12113",
    x1: 53.0232,
    y1: 23.4688,
    x2: 54.42,
    y2: 23.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#809000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B7F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_454_12113",
    x1: 56.7735,
    y1: 20.1875,
    x2: 58.6401,
    y2: 20.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CA728"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_454_12113",
    x1: 60.5,
    y1: 50.7734,
    x2: 60.5,
    y2: 55.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D2B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6667,
    stopColor: "#FDC9AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_454_12113",
    x1: 60.5,
    y1: 30.5122,
    x2: 60.5,
    y2: 31.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFB082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_454_12113",
    x1: 30.9687,
    y1: -25.9844,
    x2: 30.9687,
    y2: 133.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_454_12113",
    x1: 10.8172,
    y1: -26.9219,
    x2: 10.8172,
    y2: 132.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_454_12113",
    x1: 6.125,
    y1: 82.0625,
    x2: 51.125,
    y2: 82.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93634D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93634D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_454_12113",
    x1: 2.375,
    y1: 56.75,
    x2: 11.75,
    y2: 56.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17E51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_454_12113",
    x1: 9.40625,
    y1: 75.5,
    x2: 9.40625,
    y2: 81.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFB082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_454_12113",
    x1: 48.7813,
    y1: 75.5,
    x2: 48.7813,
    y2: 81.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFB082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB936D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_454_12113",
    x1: 28.1562,
    y1: 86.6862,
    x2: 28.1562,
    y2: 133.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17E51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_454_12113",
    x1: 92.8438,
    y1: 86.6862,
    x2: 92.8438,
    y2: 133.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17E51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_454_12113",
    x1: 24.875,
    y1: 41.2812,
    x2: 51.125,
    y2: 41.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FFBE5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_454_12113",
    x1: 69.875,
    y1: 41.2812,
    x2: 96.125,
    y2: 41.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FFBE5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_454_12113",
    x1: 60.5,
    y1: 56.2812,
    x2: 60.5,
    y2: 68.4847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAE9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_454_12113",
    x1: 60.5,
    y1: 78.4691,
    x2: 60.5,
    y2: 103.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EE8372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#E7766C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8773,
    stopColor: "#DA6263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3575E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTableIcon);
export default __webpack_public_path__ + "static/media/no-table-icon.ec27faa93cb3af8ba542c7a03e55a47d.svg";
export { ForwardRef as ReactComponent };